import map from 'lodash/map'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

class NltThanks extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { product, customer, faqs = [] } = this.props
    return (
      <div className="thank-you-wrapper">
        <div className="container--small">
          <h5 className={'section-title --reduced'}>
            <i className={'icon-check-bold'} />
            {customer.nome} congratulazioni!
            <br />
            Hai noleggiato la tua nuova {product.marca} {product.modello}
          </h5>
          <p>
            Abbiamo ricevuto l'ordine correttamente e lo processeremo il prima
            possibile.
          </p>
          <p>Cosa succede ora?</p>
          <div className={'next-steps white-bg center mb-30'}>
            <h4>
              Prossimi passi
              <i className={'icon-custom-underline'} />
            </h4>
            <ul>
              <li>
                <i className={'icon-check-bold'} />
                Appena il veicolo sarà pronto verrai contattato per concordare
                la consegna
              </li>
              <li>
                <i className={'icon-check-bold'} />
                Goditi la tua nuova {product.marca} {product.modello}!
              </li>
            </ul>
          </div>
          <hr />
          <div className={'faqs'}>
            <h5 className={'section-title --reduced'}>Domande frequenti</h5>
            {map(faqs, (faqStep, index) => (
              <div
                className={`faq-wrapper ${
                  this.state[`faq-collapsed-${index}`] ? '' : 'collapsed'
                }`}
              >
                <div
                  className={'faq-title'}
                  onClick={() => {
                    this.state[`faq-collapsed-${index}`] =
                      !this.state[`faq-collapsed-${index}`]
                    this.setState(this.state)
                  }}
                >
                  {faqStep.title}
                  <i className={'icon-arrow-down title__icon'} />
                </div>
                <div className={'faq-content'}>{faqStep.content}</div>
              </div>
            ))}
          </div>
          <hr />
          <h5 className={'section-title --reduced'}>
            Dubbi? siamo qui per risponderti
          </h5>
          <p className="mb-30">
            Il nostro servizio clienti è a tua disposizione per qualsiasi dubbio
            e domanda.
          </p>
          <a
            className="thankyou-support-btn btn btn-secondary"
            href={`tel:${this.props.ui.settings.phoneNumber}`}
            title="Servizio Clienti"
          >
            <i className="icon-phone-bold" />
            <span>Contattaci</span>
          </a>
          <hr className="mt-30" />
          <div className="text-center mt-30 mb-30">
            <a className="thankyou-support-btn btn btn-primary" href="/">
              Torna alla home
            </a>
          </div>
        </div>
      </div>
    )
  }
}

NltThanks.propTypes = {
  product: PropTypes.object,
  customer: PropTypes.object,
}

const mapStateToProps = state => ({
  ui: state.ui,
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(NltThanks)
